<template>
  <NuxtRouteAnnouncer />
  <NuxtPage />
</template>

<style lang="scss">
@use "@webcarelbj/shared-components/styles";
@use "~/assets/styles/main";
</style>
